// extracted by mini-css-extract-plugin
export default {"TenantContactBlock":"TenancyViewDetails_TenantContactBlock__3Hp5U"};